module.exports = __webpack_public_path__ + "static/media/oilReserves.ebb7de72.png";